<template>
    <kgr-generic-modal
        :headline="$t('Digitale Signierung')"
        scrollable
        height="90%"
        background-color="var(--kgr-color-gray-light)"
        @close="closeDialog"
        :value="true"
        ref="modal"
    >
        <div id="draftsBox">
            <div class="template">
                <div
                    v-for="(i,pageIndex) in Array.from({ length: numPages })"
                    :key="pageIndex"
                    style="position: relative; width: 892px;"
                >
                    <canvas
                        :id="'canvas_page'+pageIndex"
                    ></canvas>
                    <div
                        :id="'canvasForm_page'+pageIndex"
                        style="position: absolute; top: 0; left: 0;"
                    >
                        <kgr-signature-field
                            v-for="(signature, sigIndex) in getSignaturesByPageIndex(pageIndex)"
                            :id="signature.id"
                            :ref="signature.id"
                            :key="sigIndex"
                            :value="signature"
                            :style="signature.getCoordinatesAsCss()"
                            :settings="settings"
                            @sign="signatureUpdated"
                            @reset="signatureUpdated"
                            @decline="signatureUpdated"
                            @inputFocus="signatureFocussed"
                            @settings="settingsUpdated"
                        />
                    </div>
                </div>
            </div>

            <kgr-generic-modal
                v-if="showSaveConfirm"
                :value="showSaveConfirm"
                :headline="$t('Digitale Signierung')"
                scrollable
                background-color="var(--kgr-color-gray-light)"
                @close="closeSaveDialog"
            >
                <template #default>
                    <span
                        v-if="nonMandatorySignatures.length === 0"
                        v-t="$t('Sie haben {signedSignatures} von {signaturesTotal} Unterschriften getätigt.', {
                            signedSignatures: signedSignatures.length,
                            signaturesTotal: signableSignatures.length
                        })"
                        class="kgr-text kgr-text--bold"
                    ></span>
                    <span
                        v-else
                        v-t="$t('Sie haben {signedSignatures} von {signaturesTotal} Unterschriften getätigt und {declinedSignatures} unterlassen.', {
                            signedSignatures: signedSignatures.length,
                            declinedSignatures: declinedSignatures.length,
                            signaturesTotal: signableSignatures.length
                        })"
                        class="kgr-text kgr-text--bold"
                    ></span>
                    <br />
                    <br />
                    <div v-if="allSignedOrDeclined">
                        <kgr-icon-active style="vertical-align: bottom"/>
                        <span class="kgr-text kgr-text--bold" v-t="'Vielen Dank, Sie haben jetzt alle Unterschriften bearbeitet.'"></span><br />
                        <br />
                        <span v-t="'Wenn Sie jetzt speichern, ist die Bearbeitung für Sie abgeschlossen.'"></span><br />
                        <br />
                    </div>
                    <div v-if="missingMandatorySignatures.length > 0">
                        <kgr-icon-active disabled style="vertical-align: bottom"/>
                        <span class="kgr-text kgr-text--bold" v-t="'Sie haben noch nicht alle Pflicht-Unterschriften geleistet:'"></span><br />
                        <br />
                        {{ $tc('Es fehlt noch eine Pflicht-Unterschrift. | Es fehlen noch {count} Pflicht-Unterschriften.', missingMandatorySignatures.length, {count: missingMandatorySignatures.length}) }}<br />
                        <br />
                    </div>
                    <div v-if="missingOptionalSignatures.length > 0">
                        <kgr-icon-active disabled style="vertical-align: bottom"/>
                        <span class="kgr-text kgr-text--bold" v-t="'Sie haben noch nicht alle optionalen Unterschriften bearbeitet:'"></span><br />
                        <br />
                        {{ $tc('Eine optionale Unterschrift wurde noch nicht bearbeitet. | {count} optionale Unterschriften wurden noch nicht bearbeitet.', missingOptionalSignatures.length, {count: missingOptionalSignatures.length}) }}<br />
                        <span v-t="'Lehnen Sie Unterschriften, die Sie nicht leisten wollen, explizit ab, in dem Sie das x-Icon klicken.'"></span><br />
                        <br />
                    </div>
                    <br />
                    <kgr-icon-info
                        style="vertical-align: bottom"
                        small
                    /> <span class="kgr-text kgr-text--italic kgr-text--small" v-t="nonMandatorySignatures.length === 0 ? 'letterSignatures.saveModal.general.note' : 'letterSignatures.saveModal.general.noteWithOptional'"></span>
                    <br /><br />

                </template>
                <template #footer>
                    <div class="kgr-postfix kgr-postfix--between kgr-postifx--gutters">
                        <div class="kgr-postfix__fixed">
                            <kgr-button
                                :value="$t('Zurück zum Bearbeiten')"
                                :pending="loading || saving"
                                :disabled="loading"
                                type="grey"
                                @click="closeSaveDialog"
                            />
                        </div>
                        <div class="kgr-postfix__fixed">
                            <kgr-button
                                :value="allSignedOrDeclined ? $t('Unterschriften speichern und abschließen') : $t('Unterschriften speichern')"
                                :pending="loading || saving"
                                :disabled="loading"
                                @click="saveDocument"
                                style="margin-left:10px"
                            />
                        </div>
                    </div>
                </template>
            </kgr-generic-modal>
        </div>
        <template #footer>
            <div class="kgr-postfix kgr-postfix--center">
                <div class="kgr-postfix__fluid kgr-text--leftAligned">
                    <kgr-button
                        :value="$t('Abbrechen')"
                        :pending="loading"
                        :disabled="loading"
                        type="grey"
                        class="kgr-button--outline"
                        @click="closeDialog"
                    />
                </div>
                <div class="kgr-postfix__fluid kgr-text--centered">
                    <div v-if="!loading">
                        <div>
                            <button
                                @click="scrollToSignature(previousSignature)"
                                :disabled="previousSignature === null"
                            >
                                <kgr-icon
                                    icon-class="arrow-left"
                                    style="display: inline-block;vertical-align: middle"
                                    :disabled="previousSignature === null"
                                />
                            </button>
                            <div
                                style="display: inline-block;vertical-align: middle"
                            >
                                {{ currentSelectedSignatureIndex === null ? $t('Unterschriften Finder') : $t('Unterschrift {num} von {total}', {num: currentSelectedSignatureIndex + 1, total: signableSignatures.length}) }}
                            </div>
                            <button
                                :disabled="nextSignature === null"
                                @click="scrollToSignature(nextSignature)"
                            >
                                <kgr-icon
                                    icon-class="arrow-right"
                                    style="display: inline-block;vertical-align: middle"
                                    :disabled="nextSignature === null"
                                />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="kgr-postfix__fluid">
                    <kgr-button
                        :value="$t('Unterschriften speichern')"
                        :pending="loading"
                        :disabled="loading || (signedSignatures.length === 0 && declinedSignatures.length === 0)"
                        type="grey"
                        @click="showSaveConfirmDialog"
                    />
                </div>
            </div>
        </template>
    </kgr-generic-modal>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
).toString();

import GenericModal from '../../common/modal/GenericModal.vue';
import Icon from '../../common/icon/Icon.vue';
import IconActive from '../../common/icon/IconActive.vue';
import IconInfo from '../../common/icon/IconInfo.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';
import SignableLetter from '../../../js/dto/letter/SignableLetter.js';
import SignatureField from './SignatureField.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
        'kgr-signature-field': SignatureField,
        'kgr-button': KgrButton,
        'kgr-icon': Icon,
        'kgr-icon-active': IconActive,
        'kgr-icon-info': IconInfo,
    },
    props: {
        letter: {
            type: SignableLetter,
            required: true,
        },
    },
    data() {
        return {
            saving: false,
            loading: true,
            signingStarted: false,
            showSaveConfirm: false,
            loadingLetters: false,
            numSignatures: 0,
            selectedSignature: null,
            signableSignatures: [],
            base64Pdf: null,
            numPages: 0,
            declineAllOptional: false,
            settings: {
                fontColor: null,
                fontSize: null,
                fontFamily: null,
            }
        };
    },
    computed: {
        missingMandatorySignatures() {
            return this.signableSignatures.filter(s => !s.signed && s.mandatory);
        },
        missingOptionalSignatures() {
            return this.signableSignatures.filter(s => !s.signed && !s.declined && !s.mandatory);
        },
        allSignedOrDeclined() {
            return this.signableSignatures.filter(s => !s.signed && !s.declined).length === 0;
        },
        nonMandatorySignatures() {
            return this.signableSignatures.filter(s => !s.mandatory);
        },
        signedSignatures() {
            return this.signableSignatures.filter(s => s.signed);
        },
        declinedSignatures() {
            return this.signableSignatures.filter(s => s.declined);
        },
        previousSignature() {
            const prevSignatureIndex = this.currentSelectedSignatureIndex !== null ? this.currentSelectedSignatureIndex - 1 : 0;
            if(prevSignatureIndex < 0) {
                return null;
            }
            return this.signableSignatures[prevSignatureIndex] ?? null;
        },
        nextSignature() {
            const nextSignatureIndex = this.currentSelectedSignatureIndex !== null ? this.currentSelectedSignatureIndex + 1 : 0;
            return this.signableSignatures[nextSignatureIndex] ?? null;
        },
        currentSelectedSignatureIndex() {
            if(this.selectedSignature === null) {
                return null;
            }

            return this.signableSignatures.findIndex(s => s.id === this.selectedSignature.id);
        },
    },
    mounted() {
        this.signableSignatures = this.letter.getSignableSignatures();
        this.openModalAndStartSigning();

        // load settings from local storage
        const settings = localStorage.getItem('signatureSettings');
        if(settings) {
            try {
                const parsedSettings = JSON.parse(settings);
                this.settings = {
                    ...this.settings,
                    ...parsedSettings,
                }
            } catch(e) {
                // ignore
            }
        }
    },
    methods: {
        settingsUpdated(settings) {
            this.settings = settings;
            localStorage.setItem('signatureSettings', JSON.stringify(this.settings));
        },
        scrollToSignature(signature) {
            if(signature === null) {
                return;
            }
            this.selectedSignature = signature;

            const canvasElement = document.getElementById(signature.id);
            if (canvasElement) {
                const offset = 100;
                this.$refs.modal.scrollTo(canvasElement, offset)
                window.setTimeout(() => {
                    this.$refs[signature.id][0].focus();
                }, 500);
            }

        },
        showSaveConfirmDialog() {
            this.showSaveConfirm = true;
        },
        getSignaturesByPageIndex(pageIndex) {
            return this.signableSignatures.filter(s => s.coordinates.pageIndex === pageIndex);
        },
        saveDocument() {
            if(this.saving) {
                return;
            }
            this.saving = true;

            axios.put(`/signable-letters/${this.letter.id}/signatures`, {
                signed : this.signedSignatures.map(s => s.serialize()),
                declined : this.declinedSignatures.map(s => s.serialize()),
            })
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.$emit('saved', this.letter);
                    this.closeSaveDialog()
                    this.closeDialog()
                })
                .catch(() => {
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => {
                    this.saving = false;
                })
            ;
        },
        closeDialog() {
            this.$emit('close');
            this.signingStarted = false;
        },
        closeSaveDialog() {
            this.showSaveConfirm = false;
        },
        signatureFocussed(signature) {
            this.selectedSignature = signature;
        },
        signatureUpdated(signature) {
            const index = this.signableSignatures.findIndex(sig => sig.id === signature.id);
            if (index !== -1) {
                this.$set(this.signableSignatures, index, signature);
            }

            this.$forceUpdate()
        },
        async createSignatureInputs() {
            const loadingTask = pdfjsLib.getDocument({ data: atob(this.base64Pdf) });
            const pdf = await loadingTask.promise;
            this.numPages = pdf.numPages;
            this.$forceUpdate();
            const scale = 1.5;

            for (let pageIndex = 0; pageIndex < this.numPages; pageIndex++) {
                const pageNum = pageIndex + 1;
                let canvas;
                let attempts = 0;
                while (!canvas && attempts < 10) {
                    canvas = document.getElementById('canvas_page' + pageIndex);
                    if (!canvas) {
                        await new Promise(resolve => setTimeout(resolve, 500));
                        attempts++;
                    }
                }

                const ctx = canvas.getContext('2d', { alpha: false, willReadFrequently: true });
                const page = await pdf.getPage(pageNum);
                const viewport = page.getViewport({ scale });
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                await page.render({ canvasContext: ctx, viewport }).promise;
                this.$forceUpdate()
            }
        },
        openModalAndStartSigning() {
            this.signingStarted = true;
            this.loading = true;
            this.numSignatures = 0;
            axios.get(`/letters/${this.letter.id}/canvas`)
                .then(response => {
                    this.base64Pdf = response.data.base64;
                    this.createSignatureInputs().finally(() => {
                        this.loading = false;
                    });
                })
                .catch(() => {
                    console.error('failed to load base64 canvas data');
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

#draftsBox {
    overflow-x: hidden;
    overflow-y: hidden;
    padding-right: 4px;
}
canvas {
    width: 892px;
    height: 1262px;
    box-sizing: border-box;
    box-shadow: 2px 3px 2px rgba(0, 0, 0, 0.2);
}
.template {
    margin: 10mm 0;
}
</style>
